var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/redact/index.ts
var REDACTED = "[REDACTED]";
var SENSITIVE_KEY_NAMES = /* @__PURE__ */ new Set([
  "password",
  "token",
  "accesstoken",
  "refreshtoken",
  "authorization",
  "secret",
  "logintoken",
  "apikey",
  "credential",
  "cookie",
  "rrn",
  "residentregistrationnumber",
  "accountnumber",
  "bankaccount"
]);
function normalizeKey(key) {
  return key.toLowerCase().replace(/[-_\s]/g, "");
}
__name(normalizeKey, "normalizeKey");
function isSensitiveKey(key) {
  return SENSITIVE_KEY_NAMES.has(normalizeKey(key));
}
__name(isSensitiveKey, "isSensitiveKey");
var RRN_PATTERN = /\b\d{6}[-\s]?[1-8]\d{6}\b/g;
var ACCOUNT_LIKE_PATTERN = /\b(?!(?:19|20)\d{2}-\d{2}-\d{2}\b)(?!0)\d{2,6}(?:-\d{2,8}){1,3}\b|\b(?!0)\d{11,14}\b/g;
var TOKEN_QUERY_PATTERN = /([?&](?:loginToken|accessToken|refreshToken|apiKey|token|access_token|refresh_token|api_key)=)[^&\s"']+/gi;
var TOKEN_JSON_PATTERN = /("(?:loginToken|accessToken|refreshToken|apiKey|token|access_token|refresh_token|api_key|authorization|secret|password)"\s*:\s*")[^"]*(")/gi;
var EMAIL_PATTERN = /[A-Za-z0-9._%+-]+@([A-Za-z0-9.-]+\.[A-Za-z]{2,})/g;
function redactText(value) {
  return value.replace(TOKEN_QUERY_PATTERN, `$1${REDACTED}`).replace(TOKEN_JSON_PATTERN, `$1${REDACTED}$2`).replace(RRN_PATTERN, REDACTED).replace(ACCOUNT_LIKE_PATTERN, REDACTED).replace(EMAIL_PATTERN, "***@$1");
}
__name(redactText, "redactText");
function redactValue(value, options) {
  const maxDepth = options?.maxDepth ?? 6;
  const maxStringLength = options?.maxStringLength ?? 2e3;
  const walk = /* @__PURE__ */ __name((v, depth) => {
    if (depth > maxDepth) {
      return REDACTED;
    }
    if (typeof v === "string") {
      const clipped = v.length > maxStringLength ? `${v.slice(0, maxStringLength)}\u2026` : v;
      return redactText(clipped);
    }
    if (Array.isArray(v)) {
      return v.map((item) => walk(item, depth + 1));
    }
    if (v && typeof v === "object") {
      const out = {};
      for (const [k, val] of Object.entries(v)) {
        out[k] = isSensitiveKey(k) ? REDACTED : walk(val, depth + 1);
      }
      return out;
    }
    return v;
  }, "walk");
  return walk(value, 0);
}
__name(redactValue, "redactValue");
export {
  SENSITIVE_KEY_NAMES,
  isSensitiveKey,
  redactText,
  redactValue
};
//# sourceMappingURL=redact.mjs.map